type Keys =
  | 'autoPlay'
  | 'autoSwitch'
  | 'autoSkip'
  | 'smallWindow'
  | 'blackBorder'
  | 'muted'

interface PlayerConfig {
  autoPlay: boolean
  autoSwitch: boolean
  autoSkip: boolean
  smallWindow: boolean
  blackBorder: boolean
  muted: boolean
  volume: number
}

let config: PlayerConfig = {
  autoPlay: false,
  autoSwitch: true,
  autoSkip: true,
  smallWindow: false,
  blackBorder: false,
  muted: false,
  volume: 0.7
}

export function usePlayerConfig() {
  const configStr = useStatefulCookie<PlayerConfig>('playerConfig')
  function getConfig() {
    if (configStr.value) {
      if (typeof configStr.value === 'string') {
        try {
          config = JSON.parse(configStr.value)
        } catch (e) {
          console.error(e)
        }
      } else {
        config = configStr.value
      }
    }
    return config
  }

  function updateConfig(key: Keys, value: boolean) {
    config[key] = value
    configStr.value = JSON.parse(JSON.stringify(config))
  }

  function setVolume(volume: number) {
    config.volume = volume
    configStr.value = JSON.parse(JSON.stringify(config))
  }

  return {
    getConfig,
    updateConfig,
    setVolume
  }
}
